/* eslint-disable import/no-unresolved */
/* eslint-disable no-undef */
/* eslint-disable prefer-const */
/* eslint-disable no-const-assign */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
import React, { useLayoutEffect, useContext, useEffect } from 'react';
import { Tag, message } from 'antd';
import { Link, useRouteMatch, useLocation, useHistory } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { useQuery, useSubscription } from '@apollo/client';
import { useSelector, useDispatch } from 'react-redux';
import { TopMenuStyle } from './style';
import { setSymbolAction, setForecastHorizonAction, setModelIdAction } from '../redux/symbols/actionCreator';
import { setAllProductAction, setSelectedProductAction } from '../redux/products/actionCreator';
import { UserAuthenticationContext } from '../config/auth/token_provider';
import { SYMBOL_BY_USER_WITH_STATUS, GET_USERS_EXPERIMENT } from '../graphql-query/graphql-query';
import { setDailogStatusAction } from '../redux/pricingLayoutDailog/actionCreator';
import { setAllSymbolAction } from '../redux/allSymbols/actionCreator';
import { setUsersExperimentAction } from '../redux/experiments/actionCreator';
import { login, logOut, setAuthToken } from '../redux/authentication/actionCreator';

const TopMenu = () => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  const refreshTokenURL = 'https://azb2cauth-dev.azurewebsites.net/api/refreshUserToken';
  const { user, session } = useContext(UserAuthenticationContext);
  const userExperimentsData = useSelector(state => state.userExperimentsData);
  const dispatch = useDispatch();
  const selectedProduct = useSelector(product => product.productData);
  const authToken = useSelector(state => state.auth);
  const symbolDropdown = useSubscription(SYMBOL_BY_USER_WITH_STATUS);
  const userExperiments = useQuery(GET_USERS_EXPERIMENT);

  const onSelectingSymbol = (symbolObj, selectedForecastHorizon) => {
    dispatch(setSymbolAction(symbolObj));
    dispatch(setModelIdAction(symbolObj.models[0].id));
    dispatch(setForecastHorizonAction(selectedForecastHorizon));
  };

  const checkAllowedFeatures = feature => {
    let allowedFeatures = session.allowed_features;
    return allowedFeatures.includes(feature);
  };

  useEffect(() => {
    checkTokenValidityandRefreshToken();
  }, []);

  useEffect(() => {
    if (!userExperiments.loading && userExperiments.data && userExperiments.data.core_web_experiments.length > 0) {
      for (let index = 0; index < userExperiments.data.core_web_experiments.length; index++) {
        for (const experimentVariable in userExperiments.data.core_web_experiments[index].experiment_config) {
          userExperimentsData.allUserExperimentVariables[experimentVariable] =
            userExperiments.data.core_web_experiments[index].experiment_config[experimentVariable];
        }
      }
      setUsersExperimentAction(userExperiments);
    }
  }, [userExperiments.loading, userExperiments.data]);

  useEffect(() => {
    if (symbolDropdown.loading === false && symbolDropdown.data !== undefined && symbolDropdown.data != null) {
      if (symbolDropdown.data.core_user[0].user_symbols.length > 0) {
        let uniqueProductName = symbolDropdown.data.core_user[0].user_symbols
          .map(s => s.symbol.web_product_symbol_mappings[0].product.product_name)
          .filter((value, index, array) => array.indexOf(value) === index);

        dispatch(setAllProductAction(uniqueProductName));
        selectProduct(uniqueProductName[0]);
        dispatch(setAllSymbolAction(symbolDropdown.data.core_user[0].user_symbols));
        onSelectingSymbol(
          symbolDropdown.data.core_user[0].user_symbols[0].symbol,
          symbolDropdown.data.core_user[0].user_symbols[0].symbol.forecast_horizon_list[0].forecast_horizon,
        );
      } else if (
        symbolDropdown.data.core_user[0].user_symbols.allSymbol &&
        symbolDropdown.data.core_user[0].user_symbols.allSymbol.length === 0
      ) {
        dispatch(setDailogStatusAction(true));
      }
    }
  }, [symbolDropdown.loading, symbolDropdown.data]);

  const checkTokenValidityandRefreshToken = () => {
    const tokenData = JSON.parse(localStorage.getItem('authToken'));
    if (tokenData) {
      const expirationTimeLeft = (tokenData?.id_token_claims?.exp - new Date().getTime() / 1000) / 60;
      if (expirationTimeLeft <= 0) {
        fetch(refreshTokenURL, {
          method: 'POST',
          cache: 'no-cache',
          mode: 'cors',
          body: JSON.stringify({
            refresh_token: tokenData?.refresh_token,
          }),
        })
          .then(response => response.json())
          .then(data => {
            if (!data.error) {
              localStorage.setItem('authToken', JSON.stringify(data));
              dispatch(setAuthToken(data));
              window.location.reload();
            } else {
              message.error(`${data.error}`);
              localStorage.removeItem('authToken');
              dispatch(setAuthToken(null));
              history.push('/');
              dispatch(logOut());
            }
          })
          .catch(error => message.error('Email or password is incorrect !'));
      }
    } else {
      localStorage.removeItem('authToken');
      dispatch(setAuthToken(null));
      history.push('/');
      dispatch(logOut());
    }
  };

  const selectProduct = (productName, manualSwitched) => {
    dispatch(setSelectedProductAction(productName));
    if (manualSwitched) {
      const symbolsForUser = symbolDropdown.data.core_user[0].user_symbols
        .filter(y => y.status !== 'canceled' && y.status !== 'incomplete_expired')
        .filter(z => z.symbol.web_product_symbol_mappings[0].product.product_name === productName)[0];
      onSelectingSymbol(symbolsForUser.symbol, symbolsForUser.symbol.forecast_horizon_list[0].forecast_horizon);
    }
  };

  const getProductData = () => {
    if (symbolDropdown.loading === false && symbolDropdown.data !== undefined && symbolDropdown.data != null) {
      const productForUser = symbolDropdown.data.core_user[0].user_symbols;
      let uniqueProductName = productForUser
        .map(s => s.symbol.web_product_symbol_mappings[0].product.product_name)
        .filter((value, index, array) => array.indexOf(value) === index);
      return uniqueProductName.map(productName => (
        <li key={productName} value={productName}>
          <Link onClick={() => selectProduct(productName, true)} to="#">
            {productName}
          </Link>
          {location.pathname !== '/' && <ul className="subMenu">{getSymbolData(productName)}</ul>}
        </li>
      ));
    }
    return null;
  };

  const getSymbolData = productSelectedName => {
    if (symbolDropdown.loading === false && symbolDropdown.data !== undefined && symbolDropdown.data != null) {
      const symbolsForUser = symbolDropdown.data.core_user[0].user_symbols;
      return symbolsForUser
        .filter(y => y.status !== 'canceled' && y.status !== 'incomplete_expired')
        .filter(z => z.symbol.web_product_symbol_mappings[0].product.product_name === productSelectedName)
        .map(s => (
          <li key={s.symbol.id} value={s.symbol.id}>
            <Link
              to="#"
              onClick={() => onSelectingSymbol(s.symbol, s.symbol.forecast_horizon_list[0].forecast_horizon)}
            >
              {s.status === 'trialing' && (
                <Tag
                  className="progress"
                  style={{
                    backgroundColor: 'rgb(255 211 32)',
                    display: 'inline',
                    color: 'black',
                    boxShadow: 'none',
                    border: 'none',
                    borderRadius: '16px',
                    fontSize: '10px',
                    marginLeft: '10px',
                  }}
                  color="processing"
                >
                  Trial
                </Tag>
              )}
              {s.status !== 'active' && s.status !== 'trialing' ? (
                <FeatherIcon
                  icon="info"
                  size="18"
                  style={{ verticalAlign: 'middle', color: 'red', marginLeft: '10px' }}
                />
              ) : (
                <></>
              )}
              {s.symbol.name}
            </Link>
          </li>
        ));
    }
    return null;
  };

  useLayoutEffect(() => {
    const active = document.querySelector('.strikingDash-top-menu a.active');
    const activeDefault = () => {
      const megaMenu = active.closest('.megaMenu-wrapper');
      const hasSubMenuLeft = active.closest('.has-subMenu-left');
      if (!megaMenu) {
        active.closest('ul').previousSibling.classList.add('active');
        if (hasSubMenuLeft) hasSubMenuLeft.closest('ul').previousSibling.classList.add('active');
      } else {
        active.closest('.megaMenu-wrapper').previousSibling.classList.add('active');
      }
    };
    window.addEventListener('load', active && activeDefault);
    return () => window.removeEventListener('load', activeDefault);
  }, []);

  const addParentActive = event => {
    document.querySelectorAll('.parent').forEach(element => {
      element.classList.remove('active');
    });

    const hasSubMenuLeft = event.currentTarget.closest('.has-subMenu-left');
    const megaMenu = event.currentTarget.closest('.megaMenu-wrapper');
    if (!megaMenu) {
      event.currentTarget.closest('ul').previousSibling.classList.add('active');
      if (hasSubMenuLeft) hasSubMenuLeft.closest('ul').previousSibling.classList.add('active');
    } else {
      event.currentTarget.closest('.megaMenu-wrapper').previousSibling.classList.add('active');
    }
  };
  return (
    <TopMenuStyle>
      <div className="strikingDash-top-menu">
        {location.pathname !== '/onboarding' && location.pathname !== '/plan-expired' && (
          <ul>
            {checkAllowedFeatures('Home') && (
              <li>
                <Link to="/" className="parent">
                  <FeatherIcon icon="home" style={{ marginRight: '10px' }} size={16} />
                  Home
                </Link>
              </li>
            )}
            {checkAllowedFeatures('Symbols') && (
              <li className="has-subMenu">
                <Link to="/dashboard" className="parent">
                  {selectedProduct.selectedProduct ? (
                    <img src={require(`../static/img/${selectedProduct.selectedProduct}.png`)} />
                  ) : (
                    <></>
                  )}
                  {selectedProduct.selectedProduct}
                </Link>
                <ul className="subMenu">{getProductData()}</ul>
              </li>
            )}
            {checkAllowedFeatures('Co-Analyst') && (
              <li>
                <Link to="/chat-assistant" className="parent">
                  {selectedProduct.selectedProduct ? (
                    <img src={require(`../static/img/brain-icon.gif`)} style={{ width: '16px' }} />
                  ) : (
                    <></>
                  )}
                  Co-Analyst
                </Link>
              </li>
            )}
            {checkAllowedFeatures('Data Dashboard') && (
              <li>
                <Link to="/data-dashboard" className="parent">
                  <FeatherIcon icon="trello" style={{ marginRight: '10px' }} size={16} />
                  Data Dashboard
                </Link>
              </li>
            )}
            {checkAllowedFeatures('DAAS') && (
              <li>
                <Link to="/daas/dashboard" className="parent">
                  <FeatherIcon icon="activity" style={{ marginRight: '10px' }} size={16} />
                  DAAS
                </Link>
              </li>
            )}
          </ul>
        )}
      </div>
    </TopMenuStyle>
  );
};

export default TopMenu;
